module.exports = __webpack_public_path__ + "static/media/029.27e82708.jpg";